import { render, staticRenderFns } from "./CampaignName.vue?vue&type=template&id=b894ea66&scoped=true&"
import script from "./CampaignName.vue?vue&type=script&lang=js&"
export * from "./CampaignName.vue?vue&type=script&lang=js&"
import style0 from "./CampaignName.vue?vue&type=style&index=0&id=b894ea66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b894ea66",
  null
  
)

export default component.exports